import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { FieldError } from 'components/fields'

export default class RadioError extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired
  }

  renderField = field => {
    const { meta } = field
    const isVisible = meta.touched && meta.error

    return isVisible
      ? <div>
          <FieldError toShow={isVisible} message={meta.error} />
        </div>
      : null
  }

  render() {
    return (
      <Field
        name={this.props.name}
        component={field => this.renderField(field)}
      />
    )
  }
}
